import { ApiResponse } from "@/utils/ApiResponse";
import apiClient from "@/clients/apiClient";
import { MarcaVehiculoInterface } from "../../interfaces/marcaVehiculosInterfaces/MarcaVehiculo.interface";

export async function DeleteMarcaVehiculoAction (
    MarcaId: string
): Promise<ApiResponse<MarcaVehiculoInterface>> {
   const {data} = await apiClient.delete(`gvMarcaVehiculos/${MarcaId}`);
    return {
        status: 200,
        data,
        message: "Marca de vehiculo eliminado correctamente",
    };
}
    